'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PropTypes = require('prop-types');
var styled = require('styled-components');
var CustomPropTypes = require('../CustomPropTypes.js');
var constants = require('../constants.js');
var styledBreakpoint = require('./styledBreakpoint.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var gridContainer = (function () {
  let {
    styledBreakpointOptions = {
      suffix: '-container'
    },
    gridContainerMaxWidths = constants.gridContainerMaxWidths,
    gutterHalfWidth = constants.gutterHalfWidth,
    defaultProps
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return component => {
    const {
      component: newComponent,
      propNameMap,
      propNames
    } = styledBreakpoint["default"](styledBreakpointOptions)(component);
    const Component = styled__default["default"](newComponent).withConfig({
      componentId: "sc-1gs8uq3-0"
    })(["box-sizing:border-box;margin-right:auto;margin-left:auto;padding-right:", ";padding-left:", ";max-width:100%;"], gutterHalfWidth, gutterHalfWidth);
    const GridContainer = props => {
      const newProps = propNames.reduce((allNewProps, propName) => {
        const value = allNewProps[propName];
        if (!value) return allNewProps;
        return {
          ...allNewProps,
          [propName]: `width: ${gridContainerMaxWidths[propNameMap[propName]]};`
        };
      }, props);
      return /*#__PURE__*/React__default["default"].createElement(Component, newProps);
    };
    GridContainer.defaultProps = defaultProps || propNames.reduce((allDefaultProps, propName) => ({
      ...allDefaultProps,
      [propName]: gridContainerMaxWidths[propNameMap[propName]]
    }), {});
    GridContainer.propTypes = propNames.reduce((allPropTypes, propName) => ({
      ...allPropTypes,
      [propName]: PropTypes__default["default"].oneOfType([PropTypes__default["default"].oneOf(['auto']), CustomPropTypes["default"].cssWidth])
    }), {});
    return GridContainer;
  };
});

exports["default"] = gridContainer;
